import React from 'react';
import styled from '@emotion/styled';

const StyledTextarea = styled.textarea`
  width: 100%;
  padding: 16px 20px;
  border: 2px solid #DFE1E6;
  border-radius: 4px;
  font-size: 15px;
  min-height: 300px;
  resize: vertical;
  transition: all 0.2s ease;
  background-color: #FFFFFF;
  box-sizing: border-box;
  line-height: 1.6;
  font-family: inherit;
  white-space: pre-wrap !important;
  overflow-wrap: break-word;
  overflow-x: hidden;
  overflow-y: auto;
  
  &:hover {
    background-color: #FAFBFC;
    border-color: #C1C7D0;
  }
  
  &:focus {
    border-color: #4C9AFF;
    outline: none;
    box-shadow: 0 0 0 2px rgba(76, 154, 255, 0.2);
  }
  
  ${props => props.isWarning && `
    border-color: #FFAB00;
    &:focus {
      box-shadow: 0 0 0 2px rgba(255, 171, 0, 0.2);
    }
  `}
  
  ${props => props.isError && `
    border-color: #FF5630;
    &:focus {
      box-shadow: 0 0 0 2px rgba(255, 86, 48, 0.2);
    }
  `}

  &::placeholder {
    color: #6B778C;
    opacity: 0.8;
    white-space: pre-wrap;
  }
`;

const TextareaWithLineBreaks = ({ 
  value, 
  onChange, 
  name,
  maxLength,
  isWarning,
  isError,
  placeholder,
  id,
  ...props 
}) => {
  const handleChange = (e) => {
    const newValue = e.target.value;
    onChange(name, newValue);
  };

  return (
    <StyledTextarea
      id={id}
      value={value || ''}
      onChange={handleChange}
      name={name}
      maxLength={maxLength}
      isWarning={isWarning}
      isError={isError}
      placeholder={placeholder}
      rows={15}
      cols={60}
      {...props}
    />
  );
};

export default TextareaWithLineBreaks; 